import { render, staticRenderFns } from "./QDownlineStats.vue?vue&type=template&id=38f69e54&"
import script from "./QDownlineStats.vue?vue&type=script&lang=js&"
export * from "./QDownlineStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports